import { Navbar, Nav, Container, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import './css/navbar.css';
import logo from './img/homepage (38).webp';
import { Helmet } from 'react-helmet';
import { useState, useEffect, useRef } from 'react';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaWhatsapp } from 'react-icons/fa';
import { ArrowDownToLine, ChevronDown } from 'lucide-react';
import PanavBiotechPricelist from '../components/images/Panav Biotech Pricelist.pdf';
import { FiSearch } from "react-icons/fi";
import { useDispatch, useSelector } from 'react-redux';
import { getSearchProducts } from '../App/Slices/productSlice';
import { getSearchEvents } from '../App/Slices/eventsSlice';
import { getSearchBlogs } from '../App/Slices/blogSlice';
import { BsList, BsX } from 'react-icons/bs';

function NavbarComponent() {
    const dispatch = useDispatch();
    const [searchText, setSearchText] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [showProductsDropdown, setShowProductsDropdown] = useState(false);
    const location = useLocation();
    const [activeLink, setActiveLink] = useState('/');
    const [suggestions, setSuggestions] = useState({});
    const { searchevents } = useSelector((state) => state.eventsData);
    const { searchproducts } = useSelector((state) => state.productsData);
    const { searchblogs } = useSelector((state) => state.blogsData);

    const productsRef = useRef(null);
    const dropdownRef = useRef(null);
    const scrollPositionRef = useRef(0);

    const categories = [
        { title: "BY DIVISION", items: ["Orion Division", "Regal Division", "Iris Division"] },
        { title: "BY SPECIES", items: ["Companion Animals", "Farm Animals", "Poultry", "Wildlife Animals"] },
        { title: "BY CATEGORY", items: ["Vaccines", "Hyperimmune Serums", "Endocrinology", "Therapeutic Solutions", "Diagnostic Kits", "Nutraceuticals"] },
        { title: "BY DOMAIN", items: ["Cardiac Care", "Renal Care", "Skin Care", "Ear Cleansing", "Endocrine Disorder", "Urinary Support", "Anti-Emetic", "Anti-Parasitic", "Liver Care", "Immunity & Vitamins", "Digestive Health", "Anesthetic", "Antibiotic", "Pain & Inflammation", "Joint Care/Bone Health", "Feed Supplements", "Emergency Medicine", "Others"] },
    ];

    useEffect(() => {
        dispatch(getSearchProducts(searchText));
        dispatch(getSearchEvents(searchText));
        dispatch(getSearchBlogs(searchText));
    }, [searchText]);

    
    useEffect(() => {
        if (isOpen && window.innerWidth < 992) {
            // Save current scroll position
            scrollPositionRef.current = window.pageYOffset;

            // Lock body scroll
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollPositionRef.current}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
        } else {
            // Unlock body scroll
            const scrollY = scrollPositionRef.current;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.overflow = '';

            // Restore scroll position
            if (scrollY) {
                window.scrollTo(0, scrollY);
            }
        }

        // Cleanup on unmount
        return () => {
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.overflow = '';
        };
    }, [isOpen]);
    useEffect(() => {
        setActiveLink(location.pathname);
    }, [location.pathname]);

    const handleLinkClick = (link) => {
        setActiveLink(link);
        setIsOpen(false);
        setShowProductsDropdown(false);
    };

    const handleNavbarToggle = () => {
        setIsOpen(!isOpen);
    };

    const handleDownloadPricelist = () => {
        window.open(PanavBiotechPricelist, "_blank");
    };

    const handleChange = (value) => {
        setSearchText(value);
        if (!value) {
            setSuggestions({});
            return;
        }
        const filtered = { events: searchevents, blogs: searchblogs, products: searchproducts };
        setSuggestions(filtered);
    };

    // Hover logic for dropdown
    useEffect(() => {
        let hideTimeout;

        const handleMouseEnter = () => {
            clearTimeout(hideTimeout);
            setShowProductsDropdown(true);
        };

        const handleMouseLeave = (e) => {
            // Safety checks for nulls
            const related = e.relatedTarget;
            const trigger = productsRef.current;
            const dropdown = dropdownRef.current;

            // If either ref doesn’t exist, just hide safely
            if (!trigger || !dropdown) {
                setShowProductsDropdown(false);
                return;
            }

            // If mouse leaves both trigger and dropdown, hide
            hideTimeout = setTimeout(() => {
                if (
                    !related ||
                    (!trigger.contains(related) && !dropdown.contains(related))
                ) {
                    setShowProductsDropdown(false);
                }
            }, 120); // small delay to prevent flicker
        };

        const triggerEl = productsRef.current;
        const dropdownEl = dropdownRef.current;

        if (triggerEl) {
            triggerEl.addEventListener('mouseenter', handleMouseEnter);
            triggerEl.addEventListener('mouseleave', handleMouseLeave);
        }
        if (dropdownEl) {
            dropdownEl.addEventListener('mouseenter', handleMouseEnter);
            dropdownEl.addEventListener('mouseleave', handleMouseLeave);
        }

        return () => {
            clearTimeout(hideTimeout);
            if (triggerEl) {
                triggerEl.removeEventListener('mouseenter', handleMouseEnter);
                triggerEl.removeEventListener('mouseleave', handleMouseLeave);
            }
            if (dropdownEl) {
                dropdownEl.removeEventListener('mouseenter', handleMouseEnter);
                dropdownEl.removeEventListener('mouseleave', handleMouseLeave);
            }
        };
    }, []);


    const isProductsActive = activeLink === '/products' || activeLink.startsWith('/products');

    return (
        <>
            {/* Hidden crawlable links for SEO */}
            <nav style={{ display: 'none' }}>
                <a href="/">Home</a>
                <a href="/our-company">Our Company</a>
                <a href="/products">Products</a>
                <a href="/blogs">Blogs</a>
                <a href="/events">Events</a>
                <a href="/contact">Contact</a>
                <a href="/research-and-innovation">Research & Innovation</a>
            </nav>

            <Helmet>
                <link rel="canonical" href={logo} type='image/webp' />
            </Helmet>

            {/* Top strip */}
            <div className="container-fluid upperStrip d-flex items-center">
                <Container>
                    <Row className="w-100 items-center">
                      <Col
  xs={6}
  sm={8}
  md={6}
  className="d-flex flex-column text-white flex-sm-row justify-content-center justify-content-md-start align-items-center mb-1 mb-sm-0"
>
  <a
    href="mailto:info@panavbiotech.com"
    className="mb-0 me-0 me-sm-3 upperstrip-text text-decoration-none text-white"
  >
    info@panavbiotech.com
  </a>

  <a
    href="tel:+911147563428"
    className="mb-0 upperstrip-text text-decoration-none text-white"
  >
    011-47563428
  </a>
</Col>

                        <Col xs={6} sm={4} md={6} className="d-flex justify-content-center justify-content-md-end align-items-center">
                            <a href="https://www.facebook.com/panavbiotech/" target="_blank" rel="noopener noreferrer" className="text-white social-icon"><FaFacebookF /></a>
                            <a href="https://www.instagram.com/panavbiotech/?hl=en" target="_blank" rel="noopener noreferrer" className="text-white social-icon"><FaInstagram /></a>
                            <a href="https://www.linkedin.com/company/panavbiotech/posts/?feedView=all" target="_blank" rel="noopener noreferrer" className="text-white social-icon"><FaLinkedinIn /></a>
                            <a href="https://wa.me/919625404365" target="_blank" rel="noopener noreferrer" className="text-white social-icon"><FaWhatsapp /></a>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Navbar */}
            <Navbar className='navbar-cutom ' bg="white" variant="light" expand="lg" sticky="top" expanded={isOpen}>
                <LinkContainer to="/" onClick={() => handleLinkClick('/')}>
                    <Navbar.Brand>
                        <img src={logo} alt="Panav Biotech Logo" className="d-inline-block align-top custom-loggo ms-4" loading='lazy' />
                    </Navbar.Brand>
                </LinkContainer>

                <Navbar.Toggle aria-controls="navbar-nav" onClick={handleNavbarToggle} className="custom-toggler">
                    {isOpen ? <BsX className="w-6 h-6 text-black" /> : <BsList className="w-6 h-6 text-black" />}
                </Navbar.Toggle>

                <Navbar.Collapse id="navbar-nav " className='navbar-nav-links z-50'>
                    <Nav className="ms-auto align-items-lg-center container flex-end" style={{ justifyContent: 'flex-end' }}>
                        <LinkContainer to="/" onClick={() => handleLinkClick('/')}><Nav.Link className={`navLink-custom px-2 ${activeLink === '/' ? 'active-link' : ''}`}>Home</Nav.Link></LinkContainer>
                        <LinkContainer to="/our-company" onClick={() => handleLinkClick('/our-company')}><Nav.Link className={`navLink-custom px-2 ${activeLink === '/our-company' ? 'active-link' : ''}`}>Our Company</Nav.Link></LinkContainer>

                        {/* Products with mega menu */}
                        <div className="nav-dropdown" ref={productsRef}>
                            <div
                                className={`navLink-custom d-flex align-items-center px-2 ${isProductsActive ? 'active-link' : ''}`}
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    if (window.innerWidth < 992) setShowProductsDropdown(!showProductsDropdown);
                                    // else window.location.href = '/products';
                                }}
                            >
                                Products
                                <ChevronDown size={16} className={`ms-1 transition-transform ${showProductsDropdown ? 'rotate-180' : ''}`} style={{ transition: 'transform 0.2s ease' }} />
                            </div>

                            {showProductsDropdown && (
                                <div className="mega-dropdown-wrapper" ref={dropdownRef}>
                                    <div className="mega-dropdown-content">
                                        <div className="mega-dropdown-grid">
                                            {categories.map((category, idx) => (
                                                <div key={idx} className="mega-dropdown-category">
                                                    <h3 className="mega-dropdown-title">{category.title}</h3>
                                                    <ul className="mega-dropdown-list">
                                                        {category.items.map((item, i) => (
                                                            <li key={i}>
                                                                <a
                                                                    href={`/products?${category.title.replace('BY ', '').toLowerCase()}=${encodeURIComponent(item)}`}
                                                                    className="mega-dropdown-link"
                                                                    onClick={() => handleLinkClick(`/products?category=${item}`)}
                                                                >
                                                                    {item}
                                                                </a>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="mega-dropdown-footer">
                                            <a href="/products" className="mega-dropdown-cta text-white" onClick={() => handleLinkClick('/products')}>
                                                See all products
                                                <svg className="mega-dropdown-arrow" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                                                </svg>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <LinkContainer to="/blogs" onClick={() => handleLinkClick('/blogs')}><Nav.Link className={`navLink-custom px-2 ${activeLink === '/blogs' ? 'active-link' : ''}`}>Blogs</Nav.Link></LinkContainer>
                        <LinkContainer to="/events" onClick={() => handleLinkClick('/events')}><Nav.Link className={`navLink-custom px-2 ${activeLink === '/events' ? 'active-link' : ''}`}>Events</Nav.Link></LinkContainer>
                        <LinkContainer to="/contact" onClick={() => handleLinkClick('/contact')}><Nav.Link className={`navLink-custom px-2 ${activeLink === '/contact' ? 'active-link' : ''}`}>Contact</Nav.Link></LinkContainer>
                        <LinkContainer to="/research-and-innovation" onClick={() => handleLinkClick('/research-and-innovation')}><Nav.Link className={`navLink-custom px-2 ${activeLink === '/research-and-innovation' ? 'active-link' : ''}`}>Research & Innovation</Nav.Link></LinkContainer>

                        {/* Search box */}
                        <Nav.Item className="search-container mt-2 mt-lg-0 ms-lg-3 relative">
                            <div className="flex items-center w-full lg:w-64 bg-white border border-gray-300 rounded-md overflow-hidden">
                                <input type="text" placeholder="Search.." value={searchText} onChange={(e) => handleChange(e.target.value)} className="flex-1 px-3 py-2 outline-none text-sm" />
                                <div className="flex items-center justify-center bg-blue-900 text-white cursor-pointer w-10 h-10"><FiSearch size={18} /></div>
                            </div>

                            {Object.values(suggestions).some((arr) => arr.length > 0) && (
                                <div className="absolute top-full left-0 w-full lg:w-64 bg-white border border-t-0 border-gray-300 rounded-b-md shadow-md max-h-64 overflow-y-auto z-50">
                                    {suggestions?.products?.length > 0 && (
                                        <div className="p-2">
                                            <p className="text-gray-500 text-xs font-semibold mb-1">Products</p>
                                            {suggestions?.products?.map((product, idx) => (
                                                <div key={idx} className="px-2 py-1 text-sm hover:bg-gray-100 cursor-pointer rounded" onClick={() => window.location.href = `/product-details/${product?.slug}`}>{product?.title}</div>
                                            ))}
                                        </div>
                                    )}
                                    {suggestions?.blogs?.length > 0 && (
                                        <div className="p-2 border-b border-gray-200">
                                            <p className="text-gray-500 text-xs font-semibold mb-1">Blogs</p>
                                            {suggestions?.blogs?.map((blog, idx) => (
                                                <div key={idx} className="px-2 py-1 text-sm hover:bg-gray-100 cursor-pointer rounded" onClick={() => window.location.href = `/blog-details/${blog.slug}`}>{blog?.title}</div>
                                            ))}
                                        </div>
                                    )}
                                    {suggestions?.events?.length > 0 && (
                                        <div className="p-2 border-b border-gray-200">
                                            <p className="text-gray-500 text-xs font-semibold mb-1">Events</p>
                                            {suggestions?.events?.map((event, idx) => (
                                                <div key={idx} className="px-2 py-1 text-sm hover:bg-gray-100 cursor-pointer rounded" onClick={() => window.location.href = `/events?q=${searchText}`}>{event?.title}</div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}
                        </Nav.Item>

                        <div className="ms-1 cursor-pointer " onClick={handleDownloadPricelist}>
                            <div className="navLink-custom active-link text-xs p-1 flex items-center gap-1 highlight-anim rounded-md px-2">
                                Updated Pricelist <ArrowDownToLine size={20} className="animate-bounce" />
                            </div>
                        </div>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </>
    );
}

export default NavbarComponent;
